export const getStatistics = async ({ forUsers, forReservation }) => {
  const API_URL = process.env.REACT_APP_API_URL + "statistics/";
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_URL}?forUsers=${forUsers}&forReservation=${forReservation}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch statistics");
  }

  return await response.json();
};
